/**
 * @generated SignedSource<<03b3e2d6e071f05077923811c1f14dd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AttachNovaAgentFileInput = {
  id: string;
  filename: string;
  mimeType: string;
  sizeBytes?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type AttachNovaAgentFileMutation$variables = {
  input: AttachNovaAgentFileInput;
};
export type AttachNovaAgentFileMutation$data = {
  readonly attachNovaAgentFile: {
    readonly agent: {
      readonly id: string;
      readonly files: ReadonlyArray<{
        readonly fileId: string;
        readonly filename: string;
        readonly variableToken: string;
        readonly processingStatus: string;
        readonly sizeBytes: number | null;
        readonly mimeType: string | null;
      }>;
    } | null;
  } | null;
};
export type AttachNovaAgentFileMutation = {
  variables: AttachNovaAgentFileMutation$variables;
  response: AttachNovaAgentFileMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AttachNovaAgentFilePayload",
    "kind": "LinkedField",
    "name": "attachNovaAgentFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentFile",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "variableToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "processingStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sizeBytes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mimeType",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AttachNovaAgentFileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AttachNovaAgentFileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c6dc1c3882f45d3e66011d07c5e86cc1",
    "id": null,
    "metadata": {},
    "name": "AttachNovaAgentFileMutation",
    "operationKind": "mutation",
    "text": "mutation AttachNovaAgentFileMutation(\n  $input: AttachNovaAgentFileInput!\n) {\n  attachNovaAgentFile(input: $input) {\n    agent {\n      id\n      files {\n        fileId\n        filename\n        variableToken\n        processingStatus\n        sizeBytes\n        mimeType\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "07463aa00f0e99609582900b2f8521ce";

export default node;
